import {
  Component,
  HostListener,
  Inject,
  OnDestroy,
  OnInit,
  Optional,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  asyncScheduler,
  filter,
  Observable,
  observeOn,
  scan,
  Subscription,
} from 'rxjs';
import { B2bRouterService } from '@app/services/util-services/root-services/b2b-router.service';
import { OverlayEventDetail } from '@ionic/core';
import { select, Store } from '@ngrx/store';
import * as fromRoot from '@app/store';
import * as initUser from '@app/store/init-user';
import { AsyncPipe, DOCUMENT, NgClass, TitleCasePipe } from '@angular/common';
import { UserModel } from '@app/models/server/user.model';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { environment } from '@src/environments/environment';
import {
  NavigationEnd,
  NavigationStart,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { AnalyticsEventService } from '@app/services/util-services/root-services/analytics-event-service';
import { delay } from 'rxjs/operators';
import { B2bDesktopFooterComponent } from '@app/new-ui-lib/b2b-footer/components/b2b-desktop-footer/b2b-desktop-footer.component';
import { StorageUtilLibModule } from '@b2b/storage-util-lib';
import { B2bNavMenuComponent } from '@app/new-ui-lib/b2b-new-mobile-header/b2b-nav-menu/b2b-nav-menu.component';
import { RippleLoaderComponent } from '@app/new-ui-lib/b2b-loaders/components/ripple-loader/ripple-loader.component';
import { IonApp, IonContent, ModalController } from '@ionic/angular/standalone';
import { B2bPopoverV1Component } from '@app/new-ui-lib/b2b-popover-v1/b2b-popover-v1.component';

interface ScrollPositionRestore {
  event: Event;
  positions: { [K: number]: number };
  trigger: 'imperative' | 'popstate';
  idToRestore: number;
}

@Component({
  selector: 'app-web-root',
  templateUrl: './web-app.component.html',
  styleUrls: ['./web-app.component.scss'],
  standalone: true,
  imports: [
    B2bDesktopFooterComponent,
    StorageUtilLibModule,
    RouterLink,
    RouterOutlet,
    NgClass,
    TitleCasePipe,
    AsyncPipe,
    B2bNavMenuComponent,
    RippleLoaderComponent,
    IonApp,
    IonContent,
    B2bPopoverV1Component,
  ],
})
export class WebAppComponent implements OnInit, OnDestroy {
  userInfo$: Observable<UserModel>;

  selectedMenu: string;

  extranetUrl: string = environment.extranetUrl;

  selectMenuCategorySubscription$: Subscription;
  // scrollToTopSubscription$: Subscription;
  checkoutPageEventSubscription$: Subscription;

  isDesktop: boolean = this.b2bDeviceUtilService?.isDesktop();
  isBrowser: boolean;

  isCheckoutPage: boolean;
  isMobile: boolean =
    environment?.mobileApp || !this.b2bDeviceUtilService.isDesktop();
  @ViewChild('ionContentRef') ionContentRef: IonContent;

  // platform: string;
  url: string = this.b2bDeviceUtilService?.getMobileAppLink();

  scrollTop: number;

  /*@ViewChild('userPopover') userPopover: B2bPopoverComponent;*/

  constructor(
    private b2bRouterService: B2bRouterService,
    private modalController: ModalController,
    private store: Store<fromRoot.State>,
    public b2bDeviceUtilService: B2bDeviceUtilService,
    public readonly eventService: EventService,
    public router: Router,
    public analyticsEventService: AnalyticsEventService,
    @Inject(DOCUMENT) private readonly document: Document,
    private r: Renderer2,
    @Optional() @Inject('WINDOW') private window: any,
  ) {}

  @HostListener('window:popstate', ['$event'])
  dismissModal(event) {
    try {
      if (
        !this.b2bDeviceUtilService?.isServer() &&
        !this.b2bDeviceUtilService?.isDesktop() &&
        environment?.webApp
      ) {
        // if (event?.state?.modal) {
        if (this.b2bDeviceUtilService?.isProgrammaticNavigation) {
          this.b2bDeviceUtilService.isProgrammaticNavigation = false;
        } else {
          this.modalController
            ?.dismiss()
            ?.then((value: boolean) => {
              if (value) {
                this.b2bDeviceUtilService?.popModalHistory();
              }
            })
            ?.catch((reason) => {
              console.error('Inside promise catch ==> ', reason);
            });
        }
      }
    } catch (e) {
      console.error('Inside try catch ', e);
    }
  }

  /*@HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: BeforeUnloadEvent): void {
    // Show a confirmation dialog to prevent accidental exit
    event.preventDefault();
    event.returnValue = ''; // Required for most modern browsers
  }*/

  /*
    @HostListener('window:popstate', ['$event'])
    onPopState(event: Event): void {

      // Disable navigation by preventing the default behavior
      event.preventDefault();

      // Optionally show a message or take other actions
      alert('Back navigation is disabled in this screen.');
    }
  */

  ngOnInit(): void {
    if (!this.b2bDeviceUtilService.isServer()) {
      this.r.removeClass(this.document.body, 's-body');
      if (this.isDesktop) {
        this.selectMenuCategorySubscription$ =
          this.eventService.selectMenuCategoryEvent.pipe(delay(300)).subscribe({
            next: (result: { selectedTab: string }) => {
              this.selectedMenu = result?.selectedTab;
            },
          });
      }

      this.document.addEventListener('click', (event: any) => {
        if (event?.target?.id && event?.target?.id?.indexOf('int-link') > -1) {
          // LoggerService.log('event?.target?.id ', event?.target?.id);
          const anchorTag = this.document?.getElementById(event.target.id);
          // LoggerService.log('anchorTag ', anchorTag);
          if (
            anchorTag &&
            anchorTag?.innerText?.toLowerCase() === 'read more'
          ) {
            anchorTag.style.display = 'none';
            const spanTag = this.document?.getElementById(
              event.target.id + '-span',
            );
            if (spanTag) {
              spanTag.style.display = 'block';
            }
          }
        }
      });

      this.checkoutPageEventSubscription$ =
        this.eventService.checkoutPageLoadedEvent.subscribe({
          next: (result: { isCheckoutPage: boolean }) => {
            this.isCheckoutPage = result.isCheckoutPage;
          },
        });

      this.setupScrollPositionRestoration();
      this.loadInitialData();
    }
  }

  setupScrollPositionRestoration() {
    this.router.events
      .pipe(
        filter((event) => {
          if (event instanceof NavigationEnd) {
            if (
              event?.urlAfterRedirects?.indexOf('feature/checkout') > -1 ||
              event?.urlAfterRedirects?.indexOf('talk-to-ai') > -1
            ) {
              this.isCheckoutPage = true;
            } else {
              this.isCheckoutPage = false;
            }
          }
          return (
            event instanceof NavigationStart || event instanceof NavigationEnd
          );
        }),
        scan((acc: any, event) => ({
          event,
          positions: {
            ...acc.positions,
            ...(event instanceof NavigationStart
              ? {
                  [event.id]: this.scrollTop ? this.scrollTop : 0,
                }
              : {}),
          },
          trigger:
            event instanceof NavigationStart
              ? event.navigationTrigger
              : acc.trigger,
          idToRestore:
            (event instanceof NavigationStart &&
              event.restoredState &&
              event.restoredState.navigationId + 1) ||
            acc.idToRestore,
        })),
        filter(
          ({ event, trigger }) => event instanceof NavigationEnd && !!trigger,
        ),
        observeOn(asyncScheduler),
      )
      .subscribe(({ trigger, positions, idToRestore }) => {
        if (trigger === 'imperative') {
          if (this.ionContentRef) {
            this.ionContentRef.scrollToTop().then();
          }
        }

        if (trigger === 'popstate') {
          if (this.ionContentRef) {
            this.ionContentRef.scrollToPoint(0, positions[idToRestore]).then();
          }
        }
      });
  }

  loadInitialData() {
    this.store.dispatch(initUser.INIT({}));
    this.userInfo$ = this.store.pipe(select(initUser.getUser));
    this.isBrowser = !this.b2bDeviceUtilService?.isServer();
    // appendGtmTrackingCode(environment.gtmID);
  }

  /* openUserPopover() {
     this.userPopover?.present();
   }*/

  async openLoginPopup() {
    const module = await import('@b2b/auth-lib');

    const componentProps: {
      compData: {
        pageType: string;
        isModal: boolean;
        disablePageNavigation: boolean;
      };
    } = {
      compData: {
        pageType: 'login',
        isModal: true,
        disablePageNavigation: true,
      },
    };

    const modal: HTMLIonModalElement = await this.modalController.create({
      component: module.AuthModalComponent,
      componentProps,
      initialBreakpoint: 1,
      cssClass: 'auth-modal',
    });

    modal.onDidDismiss().then((result: OverlayEventDetail<{}>) => {
      if (result && result?.data) {
      }
    });
    return await modal.present();
  }

  login() {
    this.router.navigateByUrl('/auth/login').then();
  }

  register() {
    this.router.navigateByUrl('/auth/register').then();
  }

  rewards() {
    this.router.navigateByUrl('/company/membership').then();
  }

  logout(): void {
    this.eventService.loggedOutEvent.emit();
  }

  ngOnDestroy(): void {
    if (this.selectMenuCategorySubscription$) {
      this.selectMenuCategorySubscription$.unsubscribe();
    }
  }

  onScroll(event: any) {
    this.scrollTop = event?.detail?.scrollTop;
  }
}
